




































































































import Vue from "vue";

import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { Promotion } from "../models/Promotion";

export default Vue.extend({
  mixins: [pagination, permission, dialog],
  data() {
    const promotions: Promotion[] = [];
    return { promotions };
  },
  computed: {
    hasPromotionCreatePermission() {
      return (this as any).hasPermission(PermissionName.PROMOTION_CREATE);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();

    await Promise.all([this.getPromotions()]);
  },
  watch: {
    async "$route.query"() {
      await this.getPromotions();
    }
  },
  methods: {
    async getPromotions() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.promotionUseCase.getPromotions(form);

        this.promotions = data;
        (this as any).setPaginationMeta(meta);
      } catch (error) {
        console.log(error.response);
      }
    },
    goToPromotionCreatePage() {
      this.$router.push({ name: "PromotionCreatePage" });
    },
    goToPromotionDetailPage(id: any) {
      this.$router.push({ name: "PromotionDetailPage", params: { id } });
    },
    goToPromotionUpdatePage(id: any) {
      this.$router.push({ name: "PromotionUpdatePage", params: { id } });
    },
    async deletePromotionDialog(promotion: Promotion) {
      const isComfirmed = await (this as any).alertConfirm(
        "ลบ Promotion",
        `คุณต้องการที่จะลบ Promotion ${promotion.name} ใช่ไหม?`
      );
      if (isComfirmed) {
        this.deletePromotion(promotion.id!);
      }
    },
    async deletePromotion(id: number) {
      try {
        await (this as any).$dep.promotionUseCase.deletePromotion(id);
        (this as any).alertSuccess("Success", "ลบ Promotion สำเร็จ");
        this.getPromotions();
      } catch (error) {
        console.log(error);
      }
    }
  }
});
